var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{class:_vm.value < 1 ? 'negative': 'positive'},[_vm._v(_vm._s(_vm.percentage.toFixed(2))+"% "),_c('i',{class:_vm.value < 1 ? 'el-icon-bottom-right' : 'el-icon-top-right'})])
}
var staticRenderFns = []

export { render, staticRenderFns }